import AdobeNumberField from "../../../../AdobeAriaLib/AdobeNumberField";
import AdobeYearField from "../../../../AdobeAriaLib/AdobeYearField";

interface IFormDisposalYears {
    value: Record<string, any>,
    label: string
    entityName: string
    required: boolean
    onChange: Function
    disabled?: boolean
}

export default function FormDisposalYears({ value, disabled, label, entityName, required, onChange }: IFormDisposalYears) {
    const formKey = 'disposalYears';

    function handleYearChange(value: string) {
        const newValue = {
            disposeMaterialFromYear: value,
            disposeMaterialOlderThanYears: undefined
        }
        onChange(newValue, formKey);
    }

    function handleMaterialAgeChange(value: string) {
        const newValue = {
            disposeMaterialOlderThanYears: value,
            disposeMaterialFromYear: undefined
        }
        onChange(newValue, formKey);
    }

    return (
        <div>
            <hr className="margin__none"></hr>
            <div className="form-disposal-years__wrapper">
                <div className="form-disposal-years__year-item">
                    <AdobeNumberField
                        value={value?.disposeMaterialOlderThanYears ?? ''}
                        onChangeText={handleMaterialAgeChange}
                        label={'Material older than (years)'}
                        visibleLabel={true}
                        required={false}
                        className=""
                        disabled={false}
                        max={100}
                        min={1} />
                </div>
                <div className="form-disposal-years__decision">
                    <p className="xsmall">Or</p>
                </div>
                <div className="form-disposal-years__year-item">
                    <AdobeYearField
                        value={value?.disposeMaterialFromYear ?? ''}
                        onChangeText={handleYearChange}
                        label={'Specific year'}
                        visibleLable={true}
                        required={false}
                        className=""
                        disabled={false}
                        max={9999}
                        min={1800} />
                </div>
            </div>
            <hr className="form-disposal-years__bottom-separator"></hr>
        </div>
    )
}